module.exports = __webpack_public_path__ + "img/admin_adv_12.5242a921.png";